import type { EditorAPI } from '#packages/editorAPI';
import { getAppState } from './appState';

export const getOpenDataPanelOnStart = (editorAPI: EditorAPI) =>
  !!getAppState(editorAPI).openDataPanelOnStart;
